import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  ar: {
    // App
    appName: "HELCOO",
    appTagline: "منصة HELCOO المتكاملة",
    
    // Navigation
    home: "الرئيسية",
    chat: "المحادثة",
    images: "الصور",
    video: "الفيديو",
    voice: "الصوت",
    summarize: "التلخيص",
    settings: "الإعدادات",
    assistants: "المساعدين",
    history: "السجل",
    
    // Auth
    login: "تسجيل الدخول",
    register: "حساب جديد",
    logout: "تسجيل الخروج",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم",
    loginWithGoogle: "الدخول بحساب Google",
    enterBtn: "دخول",
    createAccount: "إنشاء حساب",
    or: "أو",
    backToHome: "العودة للصفحة الرئيسية",
    emailRegistered: "البريد الإلكتروني مسجل مسبقاً",
    invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    loginSuccess: "تم تسجيل الدخول بنجاح!",
    registerSuccess: "تم إنشاء الحساب بنجاح!",
    errorOccurred: "حدث خطأ، حاول مرة أخرى",
    
    // Landing
    startChat: "ابدأ المحادثة",
    createImage: "أنشئ صورة",
    fast: "سريع",
    secure: "آمن",
    smart: "ذكي",
    advanced: "متقدم",
    availableTools: "الأدوات المتاحة",
    allInOnePlace: "كل ما تحتاجه في مكان واحد",
    poweredBy: "مدعوم بأحدث التقنيات",
    
    // Features
    smartChat: "محادثة ذكية",
    smartChatDesc: "تحدث مع مساعد HELCOO الذكي",
    imageGenEdit: "توليد وتعديل الصور",
    imageGenEditDesc: "أنشئ وعدّل صوراً مذهلة",
    voiceConvert: "تحويل الصوت",
    voiceConvertDesc: "حوّل الصوت إلى نص فوري",
    textSummarize: "تلخيص النصوص",
    textSummarizeDesc: "ملخصات ذكية في ثوانٍ",
    
    // Chat
    startNewChat: "ابدأ محادثة جديدة",
    typeMessage: "اكتب رسالتك هنا...",
    aiWillRespond: "اكتب رسالتك وسيقوم HELCOO بالرد عليك فوراً",
    poweredByGPT: "مدعوم بـ HELCOO",
    conversations: "المحادثات",
    loading: "جاري التحميل...",
    noConversations: "لا توجد محادثات",
    listen: "استماع",
    stop: "إيقاف",
    greetings: ["مرحباً", "أهلاً", "Hello"],
    voiceModeActive: "وضع المحادثة الصوتية",
    voiceModeRecording: "جاري التسجيل...",
    voiceModeReplying: "جاري الرد...",
    voiceModeEnabled: "تم تفعيل وضع المحادثة الصوتية - تحدث وسيرد عليك صوتياً!",
    voiceModeDisabled: "تم إيقاف وضع المحادثة الصوتية",
    voiceModePlaceholder: "وضع المحادثة الصوتية - تحدث أو اكتب...",
    startVoiceMode: "بدء المحادثة الصوتية",
    stopVoiceMode: "إيقاف المحادثة الصوتية",
    audioError: "خطأ في تشغيل الصوت",
    analyzingAudio: "جاري تحليل الصوت...",
    audioSuccess: "تم تحويل الصوت بنجاح",
    audioAnalysisError: "خطأ في تحليل الصوت. حاول مرة أخرى.",
    imageSelected: "تم اختيار الصورة - اضغط إرسال",
    imageReadError: "خطأ في قراءة الصورة",
    imageAnalysisError: "خطأ في تحليل الصورة. حاول مرة أخرى.",
    imageFromGallery: "صورة من المعرض",
    takePhoto: "التقاط صورة",
    analyzeFile: "ملف للتحليل",
    fileSelected: "تم اختيار الملف",
    fileReadError: "خطأ في قراءة الملف",
    fileAnalysisError: "خطأ في تحليل الملف",
    noImageSelected: "لا توجد صورة محددة",
    addImageDescription: "أضف وصفاً للصورة...",
    addFileQuestion: "أضف سؤالاً عن الملف...",
    
    // Image
    imageGeneration: "توليد الصور",
    imageDesc: "أنشئ صوراً مذهلة مع HELCOO",
    enterPrompt: "اكتب وصف الصورة...",
    generate: "توليد",
    edit: "تعديل",
    editImage: "تعديل الصورة",
    uploadImage: "ارفع صورة للتعديل",
    editInstructions: "اكتب تعليمات التعديل...",
    applyEdit: "تطبيق التعديل",
    download: "تحميل",
    
    // Speech
    speechToText: "تحويل الصوت لنص",
    speechDesc: "حوّل الكلام المنطوق إلى نص مكتوب",
    startRecording: "ابدأ التسجيل",
    stopRecording: "إيقاف التسجيل",
    recording: "جاري التسجيل...",
    transcribing: "جاري التحويل...",
    transcribedText: "النص المحول",
    copy: "نسخ",
    copied: "تم النسخ!",
    
    // Summarize
    textSummarization: "تلخيص النصوص",
    summarizeDesc: "احصل على ملخص ذكي لأي نص",
    enterText: "اكتب أو الصق النص هنا...",
    summarizeBtn: "تلخيص",
    summary: "الملخص",
    
    // Settings
    settingsTitle: "الإعدادات",
    customizeExperience: "خصص تجربتك في التطبيق",
    account: "الحساب",
    appearance: "المظهر",
    chooseTheme: "اختر المظهر المناسب لك",
    light: "فاتح",
    dark: "داكن",
    auto: "تلقائي",
    lightDesc: "مظهر نهاري",
    darkDesc: "مظهر ليلي",
    autoDesc: "حسب الوقت",
    currentTheme: "المظهر الحالي",
    aboutApp: "حول التطبيق",
    version: "الإصدار",
    modelsUsed: "النماذج المستخدمة",
    chatAndSummarize: "المحادثة والتلخيص",
    imageGen: "توليد الصور",
    voiceConversion: "تحويل الصوت",
    language: "اللغة",
    arabic: "العربية",
    english: "English",
    
    // Additional translations
    newGenerate: "إنشاء جديد",
    editImageMode: "تعديل صورة",
    originalImageForEdit: "الصورة الأصلية للتعديل",
    editPromptPlaceholder: "صف التعديلات التي تريدها... مثال: أضف نظارات شمسية، غيّر الخلفية إلى شاطئ",
    generatePromptPlaceholder: "صف الصورة التي تريد إنشاءها... مثال: قطة فضائية تطير بين النجوم",
    uploadImageBtn: "رفع صورة",
    editingImage: "جاري التعديل...",
    generatingImage: "جاري الإنشاء...",
    editImageBtn: "تعديل الصورة",
    generateImageBtn: "إنشاء الصورة",
    creatingImage: "جاري إنشاء صورتك المميزة...",
    editingImageProgress: "جاري تعديل الصورة...",
    editYourImage: "عدّل على صورتك",
    createFirstImage: "أنشئ صورتك الأولى",
    editImageDescription: "اكتب التعديلات التي تريدها على الصورة وسيقوم HELCOO بتنفيذها",
    generateImageDescription: "اكتب وصفاً تفصيلياً للصورة التي تريدها أو ارفع صورة للتعديل عليها",
    imageEditSuccess: "تم تعديل الصورة بنجاح!",
    imageGenSuccess: "تم إنشاء الصورة بنجاح!",
    imageEditError: "حدث خطأ في تعديل الصورة",
    imageGenError: "حدث خطأ في إنشاء الصورة",
    imageDownloaded: "تم تحميل الصورة",
    canEditImage: "يمكنك الآن التعديل على الصورة",
    pleaseSelectImage: "يرجى اختيار صورة",
    imageSizeLimit: "حجم الصورة يتجاوز 10 ميجابايت",
    
    // Speech page
    convertSpeechToText: "حوّل التسجيلات الصوتية إلى نص بسهولة",
    converting: "جاري التحويل...",
    pressToStop: "اضغط لإيقاف التسجيل",
    pressToStart: "اضغط للبدء في التسجيل",
    uploadAudioFile: "رفع ملف صوتي",
    supportedFormats: "الصيغ المدعومة: MP3, WAV, WEBM, M4A (الحد الأقصى: 25MB)",
    convertedText: "النص المحوّل",
    convertYourVoice: "حوّل صوتك إلى نص",
    speechDescription: "سجّل صوتك مباشرة أو ارفع ملفاً صوتياً وسيتم تحويله إلى نص مكتوب",
    speechSuccess: "تم تحويل الصوت بنجاح!",
    speechError: "حدث خطأ في تحويل الصوت",
    micError: "فشل في الوصول للميكروفون",
    recordingStarted: "بدأ التسجيل...",
    speakNow: "🎤 تحدث الآن... (سيتوقف تلقائياً)",
    noSpeechDetected: "لم يتم اكتشاف كلام، حاول مرة أخرى",
    fileSizeLimit: "حجم الملف يتجاوز 25 ميجابايت",
    textCopied: "تم نسخ النص",
    
    // Voice Call
    voiceListening: "جاري الاستماع...",
    voiceProcessing: "جاري المعالجة...",
    voiceSpeaking: "جاري الرد...",
    voiceWaiting: "انتظر أو تحدث...",
    you: "أنت",
    
    // Summarize page
    smartSummaries: "احصل على ملخصات ذكية من HELCOO",
    originalText: "النص الأصلي",
    character: "حرف",
    pasteTextHere: "الصق النص الذي تريد تلخيصه هنا...",
    summarizing: "جاري التلخيص...",
    clear: "مسح",
    summaryWillAppear: "سيظهر الملخص هنا",
    summarizeSuccess: "تم التلخيص بنجاح!",
    summarizeError: "حدث خطأ في التلخيص",
    summaryCopied: "تم نسخ الملخص",
    
    // Sidebar
    chats: "المحادثات",
    noChats: "لا توجد محادثات",
    
    // Chat page
    messageSendError: "حدث خطأ في إرسال الرسالة",
  },
  en: {
    // App
    appName: "HELCOO",
    appTagline: "Integrated HELCOO Platform",
    
    // Navigation
    home: "Home",
    chat: "Chat",
    images: "Images",
    video: "Video",
    voice: "Voice",
    summarize: "Summarize",
    settings: "Settings",
    assistants: "Assistants",
    history: "History",
    
    // Auth
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    name: "Name",
    loginWithGoogle: "Login with Google",
    enterBtn: "Login",
    createAccount: "Create Account",
    or: "or",
    backToHome: "Back to Home",
    emailRegistered: "Email already registered",
    invalidCredentials: "Invalid email or password",
    loginSuccess: "Login successful!",
    registerSuccess: "Account created successfully!",
    errorOccurred: "An error occurred, please try again",
    
    // Landing
    startChat: "Start Chat",
    createImage: "Create Image",
    fast: "Fast",
    secure: "Secure",
    smart: "Smart",
    advanced: "Advanced",
    availableTools: "Available Tools",
    allInOnePlace: "Everything you need in one place",
    poweredBy: "Powered by the latest technology",
    
    // Features
    smartChat: "Smart Chat",
    smartChatDesc: "Chat with HELCOO smart assistant",
    imageGenEdit: "Image Generation & Editing",
    imageGenEditDesc: "Create and edit stunning images",
    voiceConvert: "Voice Conversion",
    voiceConvertDesc: "Convert speech to text instantly",
    textSummarize: "Text Summarization",
    textSummarizeDesc: "Smart summaries in seconds",
    
    // Chat
    startNewChat: "Start a new conversation",
    typeMessage: "Type your message here...",
    aiWillRespond: "Type your message and HELCOO will respond instantly",
    poweredByGPT: "Powered by HELCOO",
    conversations: "Conversations",
    loading: "Loading...",
    noConversations: "No conversations",
    listen: "Listen",
    stop: "Stop",
    greetings: ["Hello", "Hi", "Hey"],
    voiceModeActive: "Voice Chat Mode",
    voiceModeRecording: "Recording...",
    voiceModeReplying: "Replying...",
    voiceModeEnabled: "Voice chat enabled - speak and get voice responses!",
    voiceModeDisabled: "Voice chat disabled",
    voiceModePlaceholder: "Voice chat mode - speak or type...",
    startVoiceMode: "Start voice chat",
    stopVoiceMode: "Stop voice chat",
    audioError: "Audio playback error",
    analyzingAudio: "Analyzing audio...",
    audioSuccess: "Audio converted successfully",
    audioAnalysisError: "Audio analysis error. Try again.",
    imageSelected: "Image selected - press send",
    imageReadError: "Error reading image",
    imageAnalysisError: "Image analysis error. Try again.",
    imageFromGallery: "Image from gallery",
    takePhoto: "Take photo",
    analyzeFile: "Analyze file",
    fileSelected: "File selected",
    fileReadError: "Error reading file",
    fileAnalysisError: "File analysis error",
    noImageSelected: "No image selected",
    addImageDescription: "Add image description...",
    addFileQuestion: "Add a question about the file...",
    
    // Image
    imageGeneration: "Image Generation",
    imageDesc: "Create stunning images with HELCOO",
    enterPrompt: "Enter image description...",
    generate: "Generate",
    edit: "Edit",
    editImage: "Edit Image",
    uploadImage: "Upload image to edit",
    editInstructions: "Enter edit instructions...",
    applyEdit: "Apply Edit",
    download: "Download",
    
    // Speech
    speechToText: "Speech to Text",
    speechDesc: "Convert spoken words to written text",
    startRecording: "Start Recording",
    stopRecording: "Stop Recording",
    recording: "Recording...",
    transcribing: "Transcribing...",
    transcribedText: "Transcribed Text",
    copy: "Copy",
    copied: "Copied!",
    
    // Summarize
    textSummarization: "Text Summarization",
    summarizeDesc: "Get a smart summary of any text",
    enterText: "Type or paste text here...",
    summarizeBtn: "Summarize",
    summary: "Summary",
    
    // Settings
    settingsTitle: "Settings",
    customizeExperience: "Customize your app experience",
    account: "Account",
    appearance: "Appearance",
    chooseTheme: "Choose your preferred theme",
    light: "Light",
    dark: "Dark",
    auto: "Auto",
    lightDesc: "Day mode",
    darkDesc: "Night mode",
    autoDesc: "Based on time",
    currentTheme: "Current theme",
    aboutApp: "About App",
    version: "Version",
    modelsUsed: "Models Used",
    chatAndSummarize: "Chat & Summarization",
    imageGen: "Image Generation",
    voiceConversion: "Voice Conversion",
    language: "Language",
    arabic: "العربية",
    english: "English",
    
    // Additional translations
    newGenerate: "Create New",
    editImageMode: "Edit Image",
    originalImageForEdit: "Original image for editing",
    editPromptPlaceholder: "Describe the edits you want... Example: Add sunglasses, change background to beach",
    generatePromptPlaceholder: "Describe the image you want to create... Example: A space cat flying among stars",
    uploadImageBtn: "Upload Image",
    editingImage: "Editing...",
    generatingImage: "Generating...",
    editImageBtn: "Edit Image",
    generateImageBtn: "Generate Image",
    creatingImage: "Creating your unique image...",
    editingImageProgress: "Editing image...",
    editYourImage: "Edit your image",
    createFirstImage: "Create your first image",
    editImageDescription: "Describe the edits you want and HELCOO will apply them",
    generateImageDescription: "Write a detailed description of the image you want or upload an image to edit",
    imageEditSuccess: "Image edited successfully!",
    imageGenSuccess: "Image generated successfully!",
    imageEditError: "Error editing image",
    imageGenError: "Error generating image",
    imageDownloaded: "Image downloaded",
    canEditImage: "You can now edit the image",
    pleaseSelectImage: "Please select an image",
    imageSizeLimit: "Image size exceeds 10MB",
    
    // Speech page
    convertSpeechToText: "Convert audio recordings to text easily",
    converting: "Converting...",
    pressToStop: "Press to stop recording",
    pressToStart: "Press to start recording",
    uploadAudioFile: "Upload audio file",
    supportedFormats: "Supported formats: MP3, WAV, WEBM, M4A (Max: 25MB)",
    convertedText: "Converted Text",
    convertYourVoice: "Convert your voice to text",
    speechDescription: "Record your voice directly or upload an audio file to convert it to text",
    speechSuccess: "Audio converted successfully!",
    speechError: "Error converting audio",
    micError: "Failed to access microphone",
    recordingStarted: "Recording started...",
    speakNow: "🎤 Speak now... (will stop automatically)",
    noSpeechDetected: "No speech detected, try again",
    fileSizeLimit: "File size exceeds 25MB",
    textCopied: "Text copied",
    
    // Voice Call
    voiceListening: "Listening...",
    voiceProcessing: "Processing...",
    voiceSpeaking: "Responding...",
    voiceWaiting: "Wait or speak...",
    you: "You",
    
    // Summarize page
    smartSummaries: "Get smart summaries from HELCOO",
    originalText: "Original Text",
    character: "character",
    pasteTextHere: "Paste the text you want to summarize here...",
    summarizing: "Summarizing...",
    clear: "Clear",
    summaryWillAppear: "Summary will appear here",
    summarizeSuccess: "Summarized successfully!",
    summarizeError: "Error summarizing",
    summaryCopied: "Summary copied",
    
    // Sidebar
    chats: "Conversations",
    noChats: "No conversations",
    
    // Chat page
    messageSendError: "Error sending message",
  }
};

const LanguageContext = createContext();

export function useLanguage() {
  return useContext(LanguageContext);
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem("helcoo_language");
    return saved || "ar";
  });

  useEffect(() => {
    localStorage.setItem("helcoo_language", language);
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const isRTL = language === "ar";

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}
